import { Spin } from "antd";
import React from "react";

export function SplashScreen() {
  return (
    <div className="splash-screen text-center">
      <Spin/>
      <p className="loading-text">Please wait...</p>
    </div>
  );
}
